import ScrollSeeMoreWrapper from './ScrollSeeMoreWrapper';

export default ScrollSeeMoreWrapper;
